:host {
  @apply inline-block
    select-none;
}

@include disabled();
@include hidden-form-input();

@function get-trailing-text-input-padding($chevron-spacing) {
  @return calc(var(--calcite-toggle-spacing) + $chevron-spacing);
}

:host([scale="s"]) {
  --calcite-toggle-spacing: theme("spacing.2");
  --calcite-internal-input-text-input-padding-inline-end: #{get-trailing-text-input-padding(theme("spacing.4"))};
}

:host([scale="m"]) {
  --calcite-toggle-spacing: theme("spacing.3");
  --calcite-internal-input-text-input-padding-inline-end: #{get-trailing-text-input-padding(theme("spacing.6"))};
}

:host([scale="l"]) {
  --calcite-toggle-spacing: theme("spacing.4");
  --calcite-internal-input-text-input-padding-inline-end: #{get-trailing-text-input-padding(theme("spacing.8"))};
}

.input-wrapper {
  @apply relative;
}

.toggle-icon {
  @apply absolute flex cursor-pointer items-center;
  inset-inline-end: 0;
  inset-block: 0;
  padding-inline: var(--calcite-toggle-spacing);
  --calcite-ui-icon-color: var(--calcite-color-text-3);
}

.input-wrapper:hover .toggle-icon,
calcite-input-text:focus + .toggle-icon {
  --calcite-ui-icon-color: var(--calcite-color-text-1);
}

@include form-validation-message();
@include base-component();
